import { type FC, ReactNode } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { FormProvider, useForm } from "react-hook-form";
import { truckOrderSchema, TruckOrderSchemaProps } from "./truckOrderSchema";

type Props = {
	children: ReactNode;
	defaultValues?: TruckOrderSchemaProps;
};

const TruckOrderFormProvider: FC<Props> = ({ children, defaultValues }) => {
	const methods = useForm({
		resolver: yupResolver(truckOrderSchema),
		defaultValues: defaultValues ?? {
			order: undefined
		}
	});

	return <FormProvider {...methods}>{children}</FormProvider>;
};

export default TruckOrderFormProvider;
